var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('textarea',{staticClass:"textbox",attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"keyup":_vm.change}})])}
var staticRenderFns = []

export { render, staticRenderFns }